import styled from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const TableCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
`;

export const TableValue = styled.span`
  font-size: 19px;
  font-weight: 500;
`;

export const YearCellColor = styled.div`
  width: 12px;
  height: 12px;
  min-width: 12px;
  background-color: ${(props) => props.color};
  border-radius: 100%;
  margin-right: 8px;
`;

export const YearCellValue = styled.span`
  font-size: 16px;
  color: ${colors.grey7};
`;

export const TrendIcon = styled(ApIcon)<{ isNegative?: boolean }>`
  margin-left: -12px;
  transform: rotate(${(props) => (props.isNegative ? '90' : '270')}deg);
`;

export const TableEmptyValue = styled(TableValue)`
  margin-right: 12px;
`;
